import styles from "./AscButton.module.scss";
import classNames from "classnames";
import { If } from "react-conditional-components-renderer";
import { ClassicChevronRightIcon, LoadingSpinnerIcon } from "../AscIcons";

type AscButtonVariants =
  | "primary"
  | "secondary"
  | "white"
  | "gray"
  | "lightGray"
  | "red"
  | "PURPLE"
  | "outlined"
  | "link"
  | "pink";
type AscButtonSizes = "large" | "medium" | "small";

export interface AscButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children?: React.ReactNode;
  className?: string;
  variant?: AscButtonVariants;
  size?: AscButtonSizes;
  icon?: React.ReactNode;
  hideLinkIcon?: boolean;
  iconClassName?: string;
  squarishIcon?: boolean;
  fullWidth?: boolean;
  fitContent?: boolean;
  narrowPadding?: boolean;
  loading?: boolean;
  __testId?: string;
}

export default function AscButton({
  children,
  className,
  variant = "primary",
  size = "medium",
  disabled = false,
  icon,
  fullWidth = false,
  narrowPadding = false,
  squarishIcon,
  hideLinkIcon = false,
  fitContent = false,
  iconClassName,
  loading = false,
  __testId,
  ...rest
}: AscButtonProps) {
  return (
    <button
      data-testid={__testId}
      className={classNames(
        styles.ground,
        {
          [styles.primary]: variant === "primary",
          [styles.secondary]: variant === "secondary",
          [styles.link]: variant === "link",
          [styles.white]: variant === "white",
          [styles.gray]: variant === "gray",
          [styles.lightGray]: variant === "lightGray",
          [styles.red]: variant === "red",
          [styles.purple]: variant === "PURPLE",
          [styles.pink]: variant === "pink",
          [styles.outlined]: variant === "outlined",
          [styles.loading]: loading,
          [styles.disabled]: disabled,
          [styles.large]: size === "large",
          [styles.medium]: size === "medium",
          [styles.small]: size === "small",
          [styles.fullWidth]: fullWidth,
          [styles.fitContent]: fitContent,
          [styles.narrowPadding]: narrowPadding,
          [styles.iconOnly]: !children && icon,
          [styles.squarishIcon]: squarishIcon,
        },
        className
      )}
      disabled={disabled || loading}
      type="button"
      {...rest}
    >
      <If test={(!!icon || loading) && variant !== "link"}>
        <span className={classNames(styles.prefixIcon, iconClassName)}>
          {loading ? <LoadingSpinnerIcon /> : icon}
        </span>
      </If>
      {children}
      <If test={variant === "link" && !hideLinkIcon}>
        <span className={styles.suffixIcon}>
          {icon ? icon : <ClassicChevronRightIcon />}
        </span>
      </If>
    </button>
  );
}
